import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Icon, Typography } from "@/components/atoms";
import { LocationAddressAutocomplete } from "@/components/organisms/MyFavourites/FavouriteLocationsTable/components/LocationAddressAutocomplete";
import { poiFieldLabel } from "@/components/organisms/MyFavourites/FavouriteLocationsTable/suggestions";
import { PointsOfInterest } from "@/redux/apis/clientPoi/types";
import { useAppDispatch } from "@/redux/hooks";
import { restoreBookingDraft } from "@/redux/slices/clientBooking/clientBookingSlice";

export const BookATripPanel = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [pickup, setPickup] = useState<PointsOfInterest | null>(null);
  const [pickupText, setPickupText] = useState("");
  const [destination, setDestination] = useState<PointsOfInterest | null>(null);
  const [destinationText, setDestinationText] = useState("");

  // Hand the chosen pickup/destination off to the booking sheet's Address step, then jump to it —
  // same prefill mechanism as Replicate/Return (restoreBookingDraft merges over initialState). The
  // sheet opens on the Address step with both locations populated so the user picks up at date/time.
  const handleContinue = () => {
    if (!pickup || !destination) return;
    dispatch(restoreBookingDraft({ pickup, destination }));
    navigate("/client/booking");
  };

  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-1 flex-col px-[60px] pt-[15vh]">
        <div>
          <Typography variant="h2" className="mb-1">
            Book a trip
          </Typography>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Plan your ride in just a few clicks for a fast, easy and hassle free experience
          </Typography>
        </div>

        <div className="mt-6 flex flex-col gap-2">
          <LocationAddressAutocomplete
            value={pickupText}
            onChange={setPickupText}
            onSelect={(poi) => {
              setPickup(poi);
              setPickupText(poiFieldLabel(poi));
            }}
            includeFavourites
            placeholder="Pickup location"
            renderIcon={() => <Icon name="dot" isCustom size="md" className="text-neutral-dark-gray" />}
          />
          <LocationAddressAutocomplete
            value={destinationText}
            onChange={setDestinationText}
            onSelect={(poi) => {
              setDestination(poi);
              setDestinationText(poiFieldLabel(poi));
            }}
            includeFavourites
            placeholder="Dropoff"
            renderIcon={() => <Icon name="Location" size="md" variant="Bold" className="text-neutral-dark-gray" />}
          />
        </div>

        <Button variant="primary" size="lg" className="mt-6 w-full" disabled={!pickup || !destination} onClick={handleContinue}>
          Continue
        </Button>

        <Typography variant="small-regular" className="mt-6 w-full text-center text-neutral-dark-gray">
          &copy;{new Date().getFullYear()} - Powered by RideMinder
        </Typography>
      </div>

      {/* TODO: Referral Section — not yet implemented */}
    </div>
  );
};
